<template>
    <div class="mobile-navigation__wrapper d-lg-none">
        <div class="mobile-navigation" :class="{ open: isMobileNavigationOpen }">
            <div v-show="isNavigationInitialized">
                <ul class="breadcrumb">
                    <li v-show="!dataContainer1.parent" :class="{ 'd-flex': !dataContainer1.parent }"
                        class="align-items-center">
                        <client-only>
                            <od-portal-target name="mobile-b2b-select"></od-portal-target>
                        </client-only>
                    </li>
                    <li class="ddown w-100" v-if="
                        dataContainer1.parent && dataContainer1.parent.url
                    " @click="
                        slideTo(
                            (dataContainer1.parent &&
                                dataContainer1.parent.parent) ||
                            null,
                            true
                        )
                        ">
                        <span class="mobile-navigation__back">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-caret"></use>
                            </svg>
                            <a :href="getCategoryUrl(dataContainer1.parent.url)
                                " :title="dataContainer1.parent.details[0].name">
                                {{ dataContainer1.parent.details[0].name }}
                            </a>
                        </span>
                    </li>
                    <li class="mobile-navigation__close" @click="closeNavigation()" aria-label="Close navigation">
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-x"></use>
                        </svg>
                    </li>
                </ul>
                <ul v-menu id="menu-1" class="mainmenu w-100 m-0 menu-active">
                    <template v-if="
                        dataContainer1.parent &&
                        manufacturerCategories.includes(
                            dataContainer1.parent.id
                        )
                    ">
                        <li>
                            <a :href="getCategoryUrl(dataContainer1.parent.url)
                                " class="ddown__link ddown__link--big">
                                {{ dataContainer1.parent.details[0].name }}
                            </a>
                            <div class="ddown__divider">
                                <span>{{
                                    $translate(
                                        "OD3dprimaV2::Template.mobileMenuDivider2"
                                    )
                                }}</span>
                            </div>
                            <ul class="ddown__list">
                                <template v-for="category in dataContainer1.categories">
                                    <li class="ddown__item-full" v-if="
                                        category.details[0].name.toLowerCase() ==
                                        'other' ||
                                        category.details[0].name.toLowerCase() ==
                                        'others' ||
                                        category.details[0].name.toLowerCase() ==
                                        'weitere' ||
                                        category.details[0].name.toLowerCase() ==
                                        'övriga' ||
                                        category.id == 1519 ||
                                        category.id == 1520
                                    ">
                                        <a :href="getCategoryUrl(category.url)" class="ddown__more-btn">
                                            {{ category.details[0].name }}
                                        </a>
                                    </li>
                                    <li v-else>
                                        <a :href="getCategoryUrl(category.url)" class="ddown__list-link">
                                            {{ category.details[0].name }}
                                        </a>
                                    </li>
                                </template>
                            </ul>
                        </li>
                    </template>
                    <template v-else-if="
                        dataContainer1.parent &&
                        dataContainer1.parent.parent &&
                        filamentCategories.includes(
                            dataContainer1.parent.parent.id
                        )
                    ">
                        <li>
                            <a :href="getCategoryUrl(dataContainer1.parent.url)
                                " class="ddown__link ddown__link--big">
                                <!--                                <img class="navigation-icon" v-if="dataContainer1.parent.details[0].image2Path" :src="'/documents/' + dataContainer1.parent.details[0].image2Path" :alt="dataContainer1.parent.details[0].name">-->
                                <svg xmlns="http://www.w3.org/2000/svg">
                                    <use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="'#svg-nav-' +
                                        dataContainer1.parent.id
                                        "></use>
                                </svg>
                                {{ dataContainer1.parent.details[0].name }}
                            </a>
                            <div class="ddown__divider">
                                <span>{{
                                    $translate(
                                        "OD3dprimaV2::Template.mobileMenuDivider"
                                    )
                                }}</span>
                            </div>
                            <ul class="ddown__list">
                                <template v-for="category in dataContainer1.categories">
                                    <li class="ddown__item-full" v-if="
                                        category.details[0].name.toLowerCase() ==
                                        'other' ||
                                        category.details[0].name.toLowerCase() ==
                                        'others' ||
                                        category.details[0].name.toLowerCase() ==
                                        'weitere' ||
                                        category.details[0].name.toLowerCase() ==
                                        'övriga' ||
                                        category.id == 1519 ||
                                        category.id == 1520 ||
                                        category.id == 1158 ||
                                        category.id == 1064 ||
                                        category.id == 1038
                                    ">
                                        <a :href="getCategoryUrl(category.url)" class="ddown__more-btn">
                                            {{ category.details[0].name }}
                                        </a>
                                    </li>
                                    <li v-else>
                                        <a :href="getCategoryUrl(category.url)" class="ddown__list-link">
                                            {{ category.details[0].name }}
                                        </a>
                                    </li>
                                </template>
                            </ul>
                        </li>
                    </template>
                    <template v-else>
                        <li class="ddown" v-for="category in dataContainer1.categories" v-if="
                            (!dataContainer1.parent &&
                                menuCategories.includes(category.id)) ||
                            dataContainer1.parent
                        ">
                            <a :href="getCategoryUrl(category.url)" class="ddown__link" :class="{
                                'ddown__link--big':
                                    dataContainer1.parent &&
                                    dataContainer1.parent.parent &&
                                    hardwareCategories.includes(
                                        dataContainer1.parent.parent.id
                                    ),
                            }">
                                <!--                                <img class="navigation-icon" v-if="dataContainer1.parent && dataContainer1.parent.parent && hardwareCategories.includes(dataContainer1.parent.parent.id) && category.details[0].image2Path" :src="'/documents/' + category.details[0].image2Path" :alt="category.details[0].name">-->
                                <svg v-if="
                                    dataContainer1.parent &&
                                    dataContainer1.parent.parent &&
                                    hardwareCategories.includes(
                                        dataContainer1.parent.parent.id
                                    ) &&
                                    category.details[0].image2Path
                                " xmlns="http://www.w3.org/2000/svg">
                                    <use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="'#svg-nav-' + category.id
                                        "></use>
                                </svg>
                                {{ category.details[0].name }}
                            </a>
                            <span v-if="category.childCount > 0" @click="slideTo(category)" class="ddown__cta">
                                <svg xmlns="http://www.w3.org/2000/svg">
                                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-caret"></use>
                                </svg>
                            </span>
                        </li>
                    </template>
                </ul>
                <ul v-menu id="menu-2" class="mainmenu w-100 m-0">
                    <li class="ddown" v-for="category in dataContainer2.categories">
                        <a :href="getCategoryUrl(category.url)" class="ddown__link">
                            {{ category.details[0].name }}
                        </a>
                        <span v-if="category.childCount > 0" @click="slideTo(category)" class="ddown__cta">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-caret"></use>
                            </svg>
                        </span>
                    </li>
                </ul>
            </div>
            <template v-if="!isNavigationInitialized">
                <ul class="breadcrumb">
                    <li class="btn-close" @click="closeNavigation()" aria-label="Close navigation"></li>
                </ul>
                <loading-animation></loading-animation>
            </template>
        </div>
        <div class="mobile-navigation__overlay" @click="closeNavigation()"></div>
    </div>
</template>

<script>
import { MediaQueryHelper } from "ceres/app/helper/MediaQueryHelper";
import { isNullOrUndefined, isDefined } from "ceres/app/helper/utils";
import { mapState } from "vuex";

export default {
    props: {
        template: {
            default: "#vue-mobile-navigation",
            type: String,
        },
        initialCategory: Object,
        breakpoints: {
            type: Array,
            default: () => ["xs", "sm", "md"],
        },
        includeLanguage: Boolean,
    },

    data() {
        return {
            dataContainer1: {
                parent: {},
                categories: [],
            },
            dataContainer2: {
                parent: {},
                categories: [],
            },
            useFirstContainer: false,
            isNavigationInitialized: false,
            selectedCategory: null,
            menuCategories: [934, 935, 936, 562], //[216,217,547,198,200],
            hardwareCategories: [934, 936], //[216,198,200],
            filamentCategories: [935], //[217,547],
            manufacturerCategories: [972, 976, 974],
        };
    },

    computed: {
        ...mapState({
            navigationTree: (state) => state.navigation.tree,
            isMobileNavigationOpen: (state) =>
                state.navigation.isMobileNavigationOpen,
        }),
    },

    created() {
        this.$store.commit("setCurrentCategory", this.initialCategory);
    },

    mounted() {
        this.addEventListener();
    },

    methods: {
        addEventListener() {
            const QueryHelper = new MediaQueryHelper();
            const breakpoint = QueryHelper.getCurrentBreakpoint();

            QueryHelper.addFunction(this.loadInitialTree, this.breakpoints);
            QueryHelper.addFunction(this.closeNavigation, ["lg", "xl"]);

            if (this.breakpoints.includes(breakpoint)) {
                this.loadInitialTree();
            }
        },

        loadInitialTree() {
            if (this.navigationTree.length <= 0) {
                const categoryId =
                    this.initialCategory && this.initialCategory.id
                        ? this.initialCategory.id
                        : null;

                this.$store
                    .dispatch("loadPartialNavigationTree", categoryId)
                    .then((response) => {
                        this.$store.commit("setNavigationTree", response);
                        this.initNavigation();
                    });
            }
        },

        initNavigation() {
            if (this.initialCategory && this.initialCategory.id) {
                if (this.initialCategory.linklist === "N") {
                    this.$store.commit(
                        "setCurrentCategory",
                        this.initialCategory
                    );
                } else {
                    this.$store.dispatch("setCurrentCategoryById", {
                        categoryId: parseInt(this.initialCategory.id),
                    });
                    this.initialSlide(
                        this.$store.state.navigation.currentCategory
                    );
                }
            }

            this.dataContainer1.parent = null;
            this.dataContainer1.categories = this.navigationTree;
            this.isNavigationInitialized = true;
        },

        initialSlide(currentCategory) {
            if (currentCategory) {
                if (currentCategory.children) {
                    this.slideTo(currentCategory);
                } else if (currentCategory.parent) {
                    this.slideTo(currentCategory.parent);
                }
            }
        },

        slideTo(category, back) {
            const children = isDefined(category)
                ? category.children
                : this.navigationTree;
            const categoryId = isDefined(category) ? category.id : null;

            this.loadPartialTree(categoryId);
            this.selectedCategory = category;

            if (this.useFirstContainer) {
                this.dataContainer1.parent = category;
                this.dataContainer1.categories = children || [];

                $("#menu-2").trigger("menu-deactivated", { back: !!back });
                $("#menu-1").trigger("menu-activated", { back: !!back });
            } else {
                this.dataContainer2.parent = category;
                this.dataContainer2.categories = children || [];

                $("#menu-1").trigger("menu-deactivated", { back: !!back });
                $("#menu-2").trigger("menu-activated", { back: !!back });
            }

            this.useFirstContainer = !this.useFirstContainer;
        },

        loadPartialTree(categoryId) {
            // eslint-disable-next-line eqeqeq
            if (
                this.selectedCategory != categoryId ||
                (isDefined(this.selectedCategory) &&
                    this.selectedCategory.id !== categoryId)
            ) {
                this.$store
                    .dispatch("loadPartialNavigationTree", categoryId)
                    .then((response) => {
                        if (
                            (isNullOrUndefined(this.selectedCategory) &&
                                isNullOrUndefined(categoryId)) ||
                            (isDefined(this.selectedCategory) &&
                                this.selectedCategory.id === categoryId)
                        ) {
                            this.$store.commit(
                                "setNavigationTree",
                                response
                            );
                            this.updateDataContainers(categoryId);
                        }
                    });
            }
        },

        updateDataContainers(categoryId) {
            const containers = ["dataContainer1", "dataContainer2"];
            const category = this.getCategoryById(
                categoryId,
                this.navigationTree
            );

            for (const container of containers) {
                if (category) {
                    this[container].parent = category;
                    this[container].categories = category.children;
                } else {
                    // root level
                    this[container].parent = null;
                    this[container].categories = this.navigationTree;
                }
            }
        },

        getCategoryById(categoryId, tree) {
            for (const cat of tree) {
                if (categoryId === cat.id) {
                    return cat;
                } else if (cat.children) {
                    const foundCat = this.getCategoryById(
                        categoryId,
                        cat.children
                    );

                    if (foundCat) {
                        return foundCat;
                    }
                }
            }

            return null;
        },

        closeNavigation() {
            this.$store.commit("setIsMobileNavigationOpen", false);
        },

        getCategoryUrl(url) {
            const trailingSlash = url[0] === "/" ? "" : "/";
            const prefix = this.includeLanguage
                ? `/${App.language}${trailingSlash}`
                : "";

            return prefix + url;
        },
    },

    directives: {
        menu: {
            bind(el) {
                // add "activated" classes when menu is activated
                $(el).on("menu-activated", (event, params) => {
                    $(event.target).addClass("menu-active");
                    $(event.target).addClass(
                        params.back
                            ? "animate-in-from-left"
                            : "animate-in-from-right"
                    );
                });
                // add "deactivated" classes when menu is deactivated
                $(el).on("menu-deactivated", (event, params) => {
                    $(event.target).removeClass("menu-active");
                    $(event.target).addClass(
                        params.back
                            ? "animate-out-to-right"
                            : "animate-out-to-left"
                    );
                });
                // this removes the animation class automatically after the animation has completed
                $(el).on(
                    "animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd",
                    () => {
                        $(".mainmenu").removeClass((index, className) => {
                            return (
                                className.match(/(^|\s)animate-\S+/g) || []
                            ).join(" ");
                        });
                    }
                );
            },
        },
    },
};
</script>
